import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import axios from 'axios'
import { List, Typography, Button, Modal, Input, message } from 'antd'
import moment from 'moment'
import { fetchViewHistory } from 'src/Services/MentorServices/IntershipTaskManagementService'
import 'src/Pages/LibraryPages/librarypages.scss'

const { Text } = Typography
const { TextArea } = Input

const IssueAndReport = () => {
  const { memberId } = useParams()
  const [historyData, setHistoryData] = useState([])
  const [loading, setLoading] = useState(true)
  const [modalVisible, setModalVisible] = useState(false)
  const [selectedEntry, setSelectedEntry] = useState(null)
  const [feedback, setFeedback] = useState('')
  const [submittingFeedback, setSubmittingFeedback] = useState(false)
  const navigate = useNavigate()
  const token = localStorage.getItem('token')

  useEffect(() => {
    if (memberId) {
      fetchHistory()
    }
  }, [memberId])

  const fetchHistory = async () => {
    try {
      const data = await fetchViewHistory(memberId)
      setHistoryData(data)
      if (typeof window.updateBadgeCount === 'function') {
        window.updateBadgeCount()
      }
    } catch (error) {
      console.error('Error fetching report status:', error)
    } finally {
      setLoading(false)
    }
  }

  const handleOpenModal = (entry) => {
    setSelectedEntry(entry)
    setFeedback('')
    setModalVisible(true)
  }

  const handleSubmitFeedback = async () => {
    if (!feedback.trim()) {
      message.error('Feedback Required!')
      return
    }

    try {
      setSubmittingFeedback(true)
      await axios.post(
        `${process.env.REACT_APP_BASE_URL_API}/InternIssueChallenge/feedback`,
        {
          id: selectedEntry.id,
          feedback: feedback,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        },
      )

      message.success('Feedback successfully submitted!')

      fetchHistory()
      setHistoryData((prevData) =>
        prevData.map((item) =>
          item.id === selectedEntry.id ? { ...item, mentorFeedback: { feedback } } : item,
        ),
      )

      setModalVisible(false)
    } catch (error) {
      console.error('Error submitting feedback:', error)
      message.error('Failed To Submit Feedback')
    } finally {
      setSubmittingFeedback(false)
    }
  }

  return (
    <div className="lpg">
      <div className="lpg__head">
        <div className="lpg__head-main">
          <span className="lpg__head-ic">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
              <path d="M12 9v4M12 17h.01" />
            </svg>
          </span>
          <div>
            <h1 className="lpg__title">Issues and Challenges</h1>
            <p className="lpg__sub">Issues and challenges for this project.</p>
          </div>
        </div>
        <button type="button" className="lpg__back" onClick={() => navigate(-1)}>
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.4"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M19 12H5M11 18l-6-6 6-6" />
          </svg>{' '}
          Back
        </button>
      </div>

      {loading ? (
        <div className="lpg__state">
          <div className="lpg__spin" />
          Loading...
        </div>
      ) : (
        <div className="lpg__panel-box">
          {historyData.length === 0 ? (
            <div className="lpg__empty-row">No history found for this member.</div>
          ) : (
            <div className="lpg__acc">
              {historyData.map((entry) => (
                <div key={entry.id} className="lpg__panel is-open">
                  <div style={{ padding: 16 }}>
                    <div className="lpg__panel-name" style={{ marginBottom: 6 }}>
                      {entry.category}
                    </div>
                    <p className="lpg__sub" style={{ margin: '0 0 10px' }}>
                      Created on: {moment(entry.createdAt).format('MMMM Do YYYY, h:mm A')}
                    </p>

                    <List
                      bordered
                      dataSource={entry.questions}
                      style={{ marginTop: 10 }}
                      renderItem={(item) => (
                        <List.Item style={{ padding: '15px', display: 'block' }}>
                          <Text strong style={{ fontSize: '16px', color: '#16233f' }}>
                            Q: {item.question}
                          </Text>
                          <br />
                          <Text style={{ fontSize: '14px', color: '#6b7794' }}>
                            A: {item.answer}
                          </Text>
                        </List.Item>
                      )}
                    />

                    {entry.mentorFeedback ? (
                      <>
                        <p className="lpg__label" style={{ marginTop: 12, marginBottom: 4 }}>
                          Mentor Feedback:
                        </p>
                        <p style={{ margin: 0, fontSize: '0.9rem', color: 'var(--ink)' }}>
                          {entry.mentorFeedback ? entry.mentorFeedback.feedback : 'N/A'}
                        </p>
                      </>
                    ) : (
                      <button
                        type="button"
                        className="lpg__btn-primary"
                        style={{ marginTop: 12 }}
                        onClick={() => handleOpenModal(entry)}
                      >
                        Provide Feedback
                      </button>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {/* Modal for Feedback */}
      <Modal
        title="Provide Feedback"
        open={modalVisible}
        onCancel={() => setModalVisible(false)}
        footer={[
          <Button key="cancel" onClick={() => setModalVisible(false)}>
            Cancel
          </Button>,
          <Button
            key="submit"
            loading={submittingFeedback}
            type="primary"
            disabled={submittingFeedback}
            onClick={handleSubmitFeedback}
          >
            {submittingFeedback ? 'Submitting' : 'Submit'}
          </Button>,
        ]}
      >
        <TextArea
          rows={4}
          placeholder="Enter your feedback here..."
          value={feedback}
          onChange={(e) => setFeedback(e.target.value)}
          required
        />
      </Modal>
    </div>
  )
}

export default IssueAndReport
